import moment from 'moment';

export function dateify(date?: string|null|Date) {
    return date ? new Date(date) : null;
}

export function dateifyOrNow(date?: string|null|Date) {
    return date ? new Date(date) : new Date();
}

/** Lokální date-only `YYYY-MM-DD` (bez času/timezone) z hodnoty date-input. */
export function toDateOnly(value?: string|null|Date): string | null {
    if (!value) return null;
    const dated = new Date(value);
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${dated.getFullYear()}-${pad(dated.getMonth() + 1)}-${pad(dated.getDate())}`;
}

/** Datum ve formátu d.M.yyyy (např. 1.1.2023). */
export function fmtDate(value?: string | null | Date): string {
    return value ? moment(value).format('D.M.YYYY') : '';
}

/** Pozdější z obou dat, nebo ta druhá pokud jedna chybí. */
export function maxDate(a: Date | null, b: Date | null): Date | null {
    if (!a) return b;
    if (!b) return a;
    return a > b ? a : b;
}

/** Dřívější z obou dat, nebo ta druhá pokud jedna chybí. */
export function minDate(a: Date | null, b: Date | null): Date | null {
    if (!a) return b;
    if (!b) return a;
    return a < b ? a : b;
}

/** Datum posunuté o `days` dní (může být záporné); vrací nový objekt na začátku dne. */
export function addDays(value: string | Date, days: number): Date {
    const date = startOfDay(value);
    date.setDate(date.getDate() + days);
    return date;
}

export function startOfDay(value?: string|null|Date) {
    const date = value ? new Date(value) : new Date();
    date.setHours(0, 0, 0, 0);
    return date;
}

export function timeify(date?: string|null|Date) {
    if (!date) return null;
    const dated = new Date(date);

    return `${dated.getHours()}:${dated.getMinutes().toString().padStart(2, '0')}`;
}

export function dateFromTime(date?: string|null) {
    if (!date) return null;
    const [hours, minutes, seconds] = date.split(':');

    return seconds ? new Date(0, 0, 0, +hours, +minutes, +seconds) : new Date(0, 0, 0, +hours, +minutes);
}

export function getLastDayOfMonth(date?: string|null|Date) {
    const dated = date? new Date(date) : new Date();
    const nextMonth = new Date(dated);
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    return new Date(nextMonth.setDate(0));
}

export function isLastDayOfMonth(date?: string|null|Date) {
    const dated = date? new Date(date) : new Date();
    const nextDay = new Date(dated);
    nextDay.setDate(nextDay.getDate() + 1);

    return nextDay.getDate() === 1;
}

export function isDate(input: string | null | undefined, format: string[] = dateCzFormats) {
    if (!input) return false;
    return moment(input, format, true).isValid() as boolean;
}

export function momentDate(date: string | Date, format: string[] = dateCzFormats) {
    return moment(date, format);
}

export const dateCzFormats = [
    'D.M.YYYY',
    'D/M/YYYY',
    'D. M. YYYY',
    'D. M.', 'D.M.', 'D.M', 'D. M',
    'D.M.YY', 'D. M. YY'
]; 
